import { AuthErrorCodes } from "firebase/auth";
import { AUthErrorMessages } from "../constants/auth-constants";

export class CustomeValidation {
  static validateServerErrorMessage(error: any): string {
    let failedAuthenticationReason = '';
    if (!error.code) {
      failedAuthenticationReason = error;
      return failedAuthenticationReason;
    }

    switch (error.code) {
      case AuthErrorCodes.TOO_MANY_ATTEMPTS_TRY_LATER:
        return failedAuthenticationReason = AUthErrorMessages.toomanyAttemptsMessage;
      case AuthErrorCodes.INVALID_PASSWORD:
        return failedAuthenticationReason = AUthErrorMessages.wrongPasswordMessage;
        case AuthErrorCodes.USER_DELETED:
          return failedAuthenticationReason = AUthErrorMessages.userDoesntExist;
      default: AUthErrorMessages.unkownServerError;
        return failedAuthenticationReason = AUthErrorMessages.unkownServerError;
    }
  }
}
